"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var get_css_1 = __importDefault(require("../get-css"));

var get_class_name_1 = require("../get-class-name");

exports.propTypes = {
  boxSizing: prop_types_1["default"].string,
  clear: prop_types_1["default"].string,
  clearfix: prop_types_1["default"].bool,
  display: prop_types_1["default"].string,
  "float": prop_types_1["default"].string,
  zIndex: prop_types_1["default"].oneOfType([prop_types_1["default"].string, prop_types_1["default"].number])
};
exports.propAliases = {};
exports.propValidators = {};
var _display = {
  className: 'dspl',
  cssName: 'display',
  jsName: 'display',
  safeValue: true,
  isPrefixed: true
};
var _float = {
  className: 'flt',
  cssName: 'float',
  jsName: 'float',
  safeValue: true
};
var _clear = {
  className: 'clr',
  cssName: 'clear',
  jsName: 'clear',
  safeValue: true
};
var _zIndex = {
  className: 'z-idx',
  cssName: 'z-index',
  jsName: 'zIndex',
  safeValue: true,
  defaultUnit: ''
};
var _boxSizing = {
  className: 'box-szg',
  cssName: 'box-sizing',
  jsName: 'boxSizing',
  safeValue: true
};
exports.propEnhancers = {
  boxSizing: function boxSizing(value) {
    return get_css_1["default"](_boxSizing, value);
  },
  clear: function clear(value) {
    return get_css_1["default"](_clear, value);
  },
  clearfix: function clearfix() {
    return {
      className: "".concat(get_class_name_1.getClassNamePrefix(), "clearfix"),
      styles: "\n.".concat(get_class_name_1.getClassNamePrefix(), "clearfix:before, .").concat(get_class_name_1.getClassNamePrefix(), "clearfix:after {\n  display: table;\n  clear: both;\n  content: \"\";\n}")
    };
  },
  display: function display(value) {
    return get_css_1["default"](_display, value);
  },
  "float": function float(value) {
    return get_css_1["default"](_float, value);
  },
  zIndex: function zIndex(value) {
    return get_css_1["default"](_zIndex, value);
  }
};